




import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import StatusIcon from '@/modules/shared/components/shared/icon/StatusIcon.vue'
import AdminDepartmentIndexPageTableActions
  from '@/modules/department/components/admin/table/AdminDepartmentIndexPageTableActions.vue'
import AdminDepartmentChatId from '@/modules/department/components/admin/AdminDepartmentChatId.vue'
import EllipsisLink from '@/modules/shared/components/shared/utils/EllipsLink.vue'
import { AdminDepartmentRoute } from '@/modules/department/routes/admin-department.route'

@Component({
  components: {
    TesTr
  }
})
export default class AdminDepartmentIndexPageTableRow extends mixins(TesTableRow) {
  constructor(private readonly routes: AdminDepartmentRoute) {
    super()
  }

  columnComponents = {
    title: {
      component: EllipsisLink,
      handler: (value, row) => ({ text: value, href: this.routes.show(row.id) })
    },
    active: {
      component: StatusIcon,
      handler: value => ({ status: value })
    },
    contactable: {
      component: StatusIcon,
      handler: value => ({ status: value })
    },
    chat_id: {
      component: AdminDepartmentChatId,
      handler: (value, row) => ({
        chatId: value,
        telegramActivationCode: row.telegram_activation_code,
        class: 'row justify-center'
      })
    },
    actions: {
      component: AdminDepartmentIndexPageTableActions,
      handler: (_, row) => ({ departmentId: row.id })
    }
  }
}
